import { Outlet } from "react-router-dom";
import { TofuSidebar } from "@components/ui_v2/TofuSidebar";
import { NavbarTofuMobile } from "@components/ui_v2/NavbarTofuMobile";
import { OnboardingWizardLayout } from "@components/ui_v2/OnboardingWizardLayout";

/**
 * Layout de los cotizadores v2: mismo sidebar del wizard, pero con la columna de `.content-wide`
 * del diseño (820px a todo lo ancho disponible) en lugar del 70% que usan los formularios del tofu.
 */
const CotizadorLayout = () => (
  <OnboardingWizardLayout
    sidebar={<TofuSidebar />}
    mobileNavbar={<NavbarTofuMobile />}
    maxContentWidth={820}
    contentWidth="100%"
  >
    <Outlet />
  </OnboardingWizardLayout>
);

export default CotizadorLayout;
